const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 276,
    height: 103,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#baa3fb",
      stroke: "none"
    },
    d: "M37 19L38 20L37 19z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#612cf5",
      stroke: "none"
    },
    d: "M38 50C35.4008 47.0915 32.0308 44.0933 31.4992 40C30.601 33.0838 38.4641 26.7671 44.9961 28.6674C49.6621 30.0248 51.7007 34.1311 54 38C62.6819 33.8191 60.5327 26.9523 52.9853 22.1443C46.7229 18.1549 38.2971 18.0726 32.0008 21.9946C24.4538 26.6957 22.5597 33.617 23.0432 42C23.2864 46.2167 25.7388 53.5728 31.0023 53.6705C33.562 53.718 36.0473 51.374 38 50z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9f7ff9",
      stroke: "none"
    },
    d: "M46 19L47 20L46 19z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a98dfa",
      stroke: "none"
    },
    d: "M34 20L35 21L34 20z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a384f9",
      stroke: "none"
    },
    d: "M32 21L33 22L32 21z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e7ef9",
      stroke: "none"
    },
    d: "M53 22L54 23L53 22z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bba5fa",
      stroke: "none"
    },
    d: "M29 23L30 24L29 23z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a182fa",
      stroke: "none"
    },
    d: "M28 24L29 25L28 24z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a283f9",
      stroke: "none"
    },
    d: "M27 25L28 26L27 25z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8a0fb",
      stroke: "none"
    },
    d: "M26 26L27 27L26 26z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9471f8",
      stroke: "none"
    },
    d: "M58 27L59 28L58 27z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9d9f9e",
      stroke: "none"
    },
    d: "M151.667 27.3333C151.222 27.7777 152.278 27.7222 152.333 27.6667C152.778 27.2222 151.722 27.2778 151.667 27.3333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cbcccb",
      stroke: "none"
    },
    d: "M153 27L154 28L153 27z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      stroke: "none"
    },
    d: "M38 49C36.4462 50.3737 34.6323 51.7121 33.294 53.3102C29.6659 57.6425 32.2106 62.9397 37.0401 64.9907C43.9036 67.9055 51.6004 63.5096 51.9298 56C52.0183 53.9822 51.7746 51.8532 50.8225 50.044C49.4947 47.5207 47.408 46.2801 45 45C47.6123 43.2095 51.3955 41.2669 52.2878 37.9599C53.9078 31.9561 45.9614 27.7202 41.0008 28.2539C29.812 29.4576 29.5755 44.1936 38 49z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b096fa",
      stroke: "none"
    },
    d: "M45 28L46 29L45 28z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cbbafb",
      stroke: "none"
    },
    d: "M59 28L60 29L59 28z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#222423",
      stroke: "none"
    },
    d: "M150 28L150 33C154.992 32.168 154.992 28.832 150 28z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#757776",
      stroke: "none"
    },
    d: "M154 28L155 29L154 28z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ccbcfc",
      stroke: "none"
    },
    d: "M24 29L25 30L24 29z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9978f9",
      stroke: "none"
    },
    d: "M36 29L37 30L36 29z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#838484",
      stroke: "none"
    },
    d: "M149 29L149 32C149.696 30.4463 149.696 30.5537 149 29z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8e68f8",
      stroke: "none"
    },
    d: "M49 30L50 31L49 30z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c0acfb",
      stroke: "none"
    },
    d: "M60 30L61 31L60 30z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8b9b9",
      stroke: "none"
    },
    d: "M155 30L156 31L155 30z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3e3f3f",
      stroke: "none"
    },
    d: "M187 30L187 57C190.008 49.8314 188 38.761 188 31L192 31C190.231 30.2211 188.964 30.0876 187 30z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7a7b7a",
      stroke: "none"
    },
    d: "M221 30L221 57C223.541 50.9449 223.541 36.0551 221 30z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#383939",
      stroke: "none"
    },
    d: "M222 30C223.506 30.683 224.315 30.8259 226 31C224.494 30.317 223.685 30.1741 222 30z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bebfbf",
      stroke: "none"
    },
    d: "M226 30L226 40C227.346 36.793 227.346 33.207 226 30z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#936ff8",
      stroke: "none"
    },
    d: "M50 31L51 32L50 31z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#222423",
      stroke: "none"
    },
    d: "M188 31L188 57L192 57L192 31L188 31M222 31L222 57L226 57L226 53C228.133 54.7018 230.245 56.9417 233.015 57.5231C245.06 60.0516 247.302 36.5153 234.004 37.0779C230.48 37.227 228.009 39.5055 225 41L225 31L222 31z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141615",
      stroke: "none"
    },
    d: "M225 31L225 41C226.346 37.793 226.346 34.207 225 31z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c8b7fc",
      stroke: "none"
    },
    d: "M33 32L34 33L33 32z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#787a78",
      stroke: "none"
    },
    d: "M154 32L155 33L154 32z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d1d0d0",
      stroke: "none"
    },
    d: "M151 33L152 34L151 33z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a4a4",
      stroke: "none"
    },
    d: "M152 33L153 34L152 33z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b39afa",
      stroke: "none"
    },
    d: "M22.3333 34.6667C22.2778 34.7222 22.2222 35.7778 22.6667 35.3333C22.7222 35.2778 22.7778 34.2222 22.3333 34.6667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b49bfb",
      stroke: "none"
    },
    d: "M58 35L59 36L58 35z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7f54f7",
      stroke: "none"
    },
    d: "M22 36L22 42C22.9511 39.7147 22.9511 38.2853 22 36z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d8ccfd",
      stroke: "none"
    },
    d: "M31 36L31 42C31.9511 39.7147 31.9511 38.2853 31 36z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c1c1c1",
      stroke: "none"
    },
    d: "M88 36L89 37L88 36z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#808281",
      stroke: "none"
    },
    d: "M89 36L90 37L89 36z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#404140",
      stroke: "none"
    },
    d: "M90 36C91.5061 36.683 92.3148 36.8259 94 37C92.494 36.317 91.6852 36.1741 90 36z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#909191",
      stroke: "none"
    },
    d: "M94 36L95 37L94 36z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d0d0d0",
      stroke: "none"
    },
    d: "M95 36L96 37L95 36z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b3b4b4",
      stroke: "none"
    },
    d: "M109 36L110 37L109 36z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#494b4a",
      stroke: "none"
    },
    d: "M110 36C111.506 36.683 112.315 36.8259 114 37C112.494 36.317 111.685 36.1741 110 36z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#949595",
      stroke: "none"
    },
    d: "M114 36L115 37L114 36z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d0d1d0",
      stroke: "none"
    },
    d: "M120 36C121.769 36.7789 123.036 36.9124 125 37C123.231 36.2211 121.964 36.0876 120 36M127 36C129.052 36.8743 130.747 36.9528 133 37C130.948 36.1257 129.253 36.0472 127 36M142 36C144.052 36.8743 145.747 36.9528 148 37C145.948 36.1257 144.253 36.0472 142 36M150 36C151.769 36.7789 153.036 36.9124 155 37C153.231 36.2211 151.964 36.0876 150 36z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a5a6a5",
      stroke: "none"
    },
    d: "M165 36L166 37L165 36z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#474949",
      stroke: "none"
    },
    d: "M166 36C167.506 36.683 168.315 36.8259 170 37C168.494 36.317 167.685 36.1741 166 36z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e7f7f",
      stroke: "none"
    },
    d: "M170 36L171 37L170 36z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c0c0c0",
      stroke: "none"
    },
    d: "M171 36L172 37L171 36z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cecece",
      stroke: "none"
    },
    d: "M201 36L202 37L201 36z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#868887",
      stroke: "none"
    },
    d: "M202 36L203 37L202 36z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3f413f",
      stroke: "none"
    },
    d: "M203 36C204.248 36.6848 204.548 36.7488 206 37C204.752 36.3152 204.452 36.2512 203 36z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#787978",
      stroke: "none"
    },
    d: "M206 36L207 37L206 36z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c5c6c6",
      stroke: "none"
    },
    d: "M207 36L208 37L207 36z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d0d1d0",
      stroke: "none"
    },
    d: "M213 36C214.506 36.683 215.315 36.8259 217 37C215.494 36.317 214.685 36.1741 213 36z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b6b7b7",
      stroke: "none"
    },
    d: "M231 36L232 37L231 36z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#444645",
      stroke: "none"
    },
    d: "M232 36C233.506 36.683 234.315 36.8259 236 37C234.494 36.317 233.685 36.1741 232 36z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969696",
      stroke: "none"
    },
    d: "M236 36L237 37L236 36z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#804df8",
      stroke: "none"
    },
    d: "M53.3333 37.6667C53.2778 37.7222 53.2222 38.7778 53.6667 38.3333C53.7222 38.2778 53.7778 37.2222 53.3333 37.6667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#926ff9",
      stroke: "none"
    },
    d: "M55 37L56 38L55 37z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6a8a8",
      stroke: "none"
    },
    d: "M86 37L87 38L86 37z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#222423",
      stroke: "none"
    },
    d: "M96 53C91.0472 54.0251 87.8109 51.3612 83 51C83.7418 53.0687 84.3383 54.6638 86.2284 55.9954C94.276 61.6648 105.762 50.9798 95.8927 46.1088C93.7384 45.0455 91.3208 44.5372 89 44C91.7576 39.1577 95.4641 42.66 100 43C97.9918 36.0775 83.5693 34.1023 84.466 42.9861C84.988 48.1572 93.013 49.3784 96 53z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#909191",
      stroke: "none"
    },
    d: "M107 37L108 38L107 37z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#222423",
      stroke: "none"
    },
    d: "M119 53L120 57L125 57L125 37L120 37L120 41C118.111 39.4028 116.491 37.8713 113.995 37.3171C96.5764 33.4484 102.656 65.4268 116.576 56.3017C117.82 55.4858 118.287 54.2206 119 53z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8e8f8f",
      stroke: "none"
    },
    d: "M116 37L117 38L116 37z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f4f4f4",
      stroke: "none"
    },
    d: "M125 37L125 57C127.087 52.0273 127.087 41.9727 125 37z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#222423",
      stroke: "none"
    },
    d: "M127 37C129.259 43.6769 132.373 50.133 134 57L141 57C142.851 50.22 145.471 43.557 148 37L142 37L138 53C135.412 48.069 133.81 42.5074 133 37L127 37z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2f2f2",
      stroke: "none"
    },
    d: "M149 37L149 57C151.087 52.0272 151.087 41.9728 149 37z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#151816",
      stroke: "none"
    },
    d: "M150 37L150 57C152.42 51.2338 148.193 41.7645 154 38C152.494 37.317 151.685 37.1741 150 37z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3d3f3e",
      stroke: "none"
    },
    d: "M154 37L154 57C156.087 52.0272 156.087 41.9727 154 37z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4e4f4f",
      stroke: "none"
    },
    d: "M163 37L164 38L163 37z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#222423",
      stroke: "none"
    },
    d: "M177 52C173.821 51.6958 169.966 53.9912 167.059 52.8287C162.244 50.9035 162.219 43.2578 167.109 41.4028C170.121 40.26 173.748 42.5401 177 42C172.594 33.6047 159.085 36.3103 158.229 46C157.237 57.2391 171.872 62.2579 177 52z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969797",
      stroke: "none"
    },
    d: "M173 37L174 38L173 37z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#222423",
      stroke: "none"
    },
    d: "M213 53L213 57L216 57L216 38C213.636 38.4824 213.482 38.636 213 41C211.117 39.5458 209.337 37.8797 206.959 37.314C191.267 33.5817 193.358 62.0356 206.959 57.2469C209.266 56.4346 211.124 54.4967 213 53z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9090",
      stroke: "none"
    },
    d: "M212 37L211 41C212.656 39.5957 212.751 39.0465 212 37z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#181a19",
      stroke: "none"
    },
    d: "M213 37C214.248 37.6848 214.548 37.7488 216 38L216 57C218.398 51.2853 217 43.1692 217 37L213 37z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a9a9aa",
      stroke: "none"
    },
    d: "M217 37L217 57C219.087 52.0272 219.087 41.9727 217 37z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#565857",
      stroke: "none"
    },
    d: "M85 38L86 39L85 38z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e9e9e",
      stroke: "none"
    },
    d: "M98 38L99 39L98 38z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#717272",
      stroke: "none"
    },
    d: "M117 38L118 39L117 38z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a7a8a8",
      stroke: "none"
    },
    d: "M127 38L128 39L127 38z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#babbba",
      stroke: "none"
    },
    d: "M147 38L148 39L147 38z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#222423",
      stroke: "none"
    },
    d: "M151 38L151 57L154 57L154 38L151 38z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#989999",
      stroke: "none"
    },
    d: "M161 38L162 39L161 38z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8c8c8d",
      stroke: "none"
    },
    d: "M198 38L199 39L198 38z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c0c0c1",
      stroke: "none"
    },
    d: "M240 38L241 39L240 38z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2f7ed",
      stroke: "none"
    },
    d: "M52 39L53 40L52 39z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27e9cf",
      stroke: "none"
    },
    d: "M53 39L46 44C48.4076 47.5359 52.6497 51.3534 52.2531 56C51.7554 61.8303 44.914 67.8138 39.0008 65.8974C34.4007 64.4066 31.8252 60.1468 30 56C27.8517 57.0344 25.2577 58.0792 24.0702 60.3295C20.542 67.0153 31.8738 73.7473 37 74.6705C57.8042 78.4175 70.1563 51.7464 53 39z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d7d7d",
      stroke: "none"
    },
    d: "M84 39L85 40L84 39z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c4c5c5",
      stroke: "none"
    },
    d: "M99 39L100 40L99 39z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#adaead",
      stroke: "none"
    },
    d: "M118 39L119 40L118 39z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c8c7c7",
      stroke: "none"
    },
    d: "M133 39L134 40L133 39z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#babbbb",
      stroke: "none"
    },
    d: "M141 39L142 40L141 39z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9090",
      stroke: "none"
    },
    d: "M160 39L161 40L160 39z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9b9b",
      stroke: "none"
    },
    d: "M197 39L198 40L197 39z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73f0e0",
      stroke: "none"
    },
    d: "M51 40L52 41L51 40z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a9a9a9",
      stroke: "none"
    },
    d: "M90 40C91.5061 40.683 92.3148 40.8259 94 41C92.494 40.317 91.6852 40.1741 90 40z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#909191",
      stroke: "none"
    },
    d: "M104 40L105 41L104 40z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7b7c7b",
      stroke: "none"
    },
    d: "M112 40C113.248 40.6848 113.548 40.7488 115 41C113.752 40.3152 113.452 40.2512 112 40z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2b3b3",
      stroke: "none"
    },
    d: "M119 40L120 41L119 40z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5b5c5c",
      stroke: "none"
    },
    d: "M133 40L134 41L133 40z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a5c5b",
      stroke: "none"
    },
    d: "M141 40L142 41L141 40z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d4e4d",
      stroke: "none"
    },
    d: "M146 40L147 41L146 40z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cfcfcf",
      stroke: "none"
    },
    d: "M159 40L160 41L159 40z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7a7b7a",
      stroke: "none"
    },
    d: "M167 40C168.248 40.6848 168.548 40.7488 170 41C168.752 40.3152 168.452 40.2512 167 40z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#777877",
      stroke: "none"
    },
    d: "M204 40C205.506 40.683 206.315 40.8259 208 41C206.494 40.317 205.685 40.1741 204 40z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#828282",
      stroke: "none"
    },
    d: "M226.667 40.3333C226.222 40.7778 227.278 40.7222 227.333 40.6667C227.778 40.2223 226.722 40.2778 226.667 40.3333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#797b7a",
      stroke: "none"
    },
    d: "M231 40C232.506 40.683 233.315 40.8259 235 41C233.494 40.317 232.685 40.1741 231 40z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c3c4c3",
      stroke: "none"
    },
    d: "M83 41L83 44C83.6961 42.4463 83.6961 42.5537 83 41z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c8c9c9",
      stroke: "none"
    },
    d: "M110 41L111 42L110 41z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      stroke: "none"
    },
    d: "M111.317 41.7469C106.236 44.2273 109.073 55.283 115.772 52.392C121.874 49.7586 118.108 38.4316 111.317 41.7469z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c3c4c4",
      stroke: "none"
    },
    d: "M128 41L129 42L128 41z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c6c7c6",
      stroke: "none"
    },
    d: "M146 41L147 42L146 41z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9b9a",
      stroke: "none"
    },
    d: "M165 41L166 42L165 41z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7c7d7c",
      stroke: "none"
    },
    d: "M171 41L172 42L171 41z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9d9e9d",
      stroke: "none"
    },
    d: "M177 41L178 42L177 41z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#585958",
      stroke: "none"
    },
    d: "M196 41L197 42L196 41z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#808180",
      stroke: "none"
    },
    d: "M202 41L203 42L202 41z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      stroke: "none"
    },
    d: "M203.318 42.0324C198.095 45.3965 202.535 55.9264 208.682 51.9676C213.905 48.6035 209.464 38.0736 203.318 42.0324z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d7f7e",
      stroke: "none"
    },
    d: "M209 41L210 42L209 41z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a8a9a9",
      stroke: "none"
    },
    d: "M229 41L230 42L229 41z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      stroke: "none"
    },
    d: "M230.318 42.0324C225.005 45.4543 229.065 56.3386 235.682 51.9715C240.867 48.5494 236.467 38.0725 230.318 42.0324z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#565857",
      stroke: "none"
    },
    d: "M236 41L237 42L236 41z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a8aaa9",
      stroke: "none"
    },
    d: "M242 41L243 42L242 41z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d2c4fc",
      stroke: "none"
    },
    d: "M22.3333 42.6667C22.2778 42.7222 22.2222 43.7778 22.6667 43.3333C22.7222 43.2778 22.7778 42.2222 22.3333 42.6667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82f2e3",
      stroke: "none"
    },
    d: "M48 42L49 43L48 42z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8d8f8e",
      stroke: "none"
    },
    d: "M103 42L104 43L103 42z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2c3c3",
      stroke: "none"
    },
    d: "M140 42L141 43L140 42z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b7b8b8",
      stroke: "none"
    },
    d: "M158 42L159 43L158 42z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a1a1",
      stroke: "none"
    },
    d: "M164 42L165 43L164 42z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#808180",
      stroke: "none"
    },
    d: "M172 42L173 43L172 42z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c1c2c2",
      stroke: "none"
    },
    d: "M176 42L177 43L176 42z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d7e7d",
      stroke: "none"
    },
    d: "M201 42L202 43L201 42z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7b7c7c",
      stroke: "none"
    },
    d: "M210 42L211 43L210 42z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c9c9c9",
      stroke: "none"
    },
    d: "M228 42L229 43L228 42z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cacbca",
      stroke: "none"
    },
    d: "M89 43L90 44L89 43z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6b6c6c",
      stroke: "none"
    },
    d: "M108 43L109 44L108 43z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8b8b8",
      stroke: "none"
    },
    d: "M118 43L119 44L118 43z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#555756",
      stroke: "none"
    },
    d: "M129 43L130 44L129 43z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#939593",
      stroke: "none"
    },
    d: "M134 43L135 44L134 43z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e7f7f",
      stroke: "none"
    },
    d: "M140 43L141 44L140 43z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6d6e6d",
      stroke: "none"
    },
    d: "M145 43L146 44L145 43z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#666866",
      stroke: "none"
    },
    d: "M158 43L159 44L158 43z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8c8d8d",
      stroke: "none"
    },
    d: "M173 43L174 44L173 43z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bbbcbc",
      stroke: "none"
    },
    d: "M195 43L196 44L195 43z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdbebe",
      stroke: "none"
    },
    d: "M243.333 43.6667C243.278 43.7222 243.222 44.7778 243.667 44.3333C243.722 44.2777 243.778 43.2222 243.333 43.6667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ff5e9",
      stroke: "none"
    },
    d: "M45 44L46 45L45 44z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#919291",
      stroke: "none"
    },
    d: "M91 44L92 45L91 44z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#111312",
      stroke: "none"
    },
    d: "M107 44L107 50C107.951 47.7147 107.951 46.2853 107 44z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e4e5e5",
      stroke: "none"
    },
    d: "M108 44L108 50C108.951 47.7147 108.951 46.2853 108 44z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d2d3d3",
      stroke: "none"
    },
    d: "M129 44L130 45L129 44z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d1d1d1",
      stroke: "none"
    },
    d: "M145 44L146 45L145 44z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#868786",
      stroke: "none"
    },
    d: "M163 44L164 45L163 44z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#464847",
      stroke: "none"
    },
    d: "M195 44L195 49C195.83 46.9695 195.83 46.0305 195 44z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#858686",
      stroke: "none"
    },
    d: "M227 44L228 45L227 44z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ccbcfc",
      stroke: "none"
    },
    d: "M33 45L34 46L33 45z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8bf3e5",
      stroke: "none"
    },
    d: "M46 45L47 46L46 45z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#787978",
      stroke: "none"
    },
    d: "M84 45L85 46L84 45z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9c9c9c",
      stroke: "none"
    },
    d: "M94 45L95 46L94 45z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d8d9d8",
      stroke: "none"
    },
    d: "M163 45L163 49C163.71 47.2405 163.71 46.7595 163 45z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#808180",
      stroke: "none"
    },
    d: "M200 45L200 49C200.71 47.2405 200.71 46.7595 200 45z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8c8d8d",
      stroke: "none"
    },
    d: "M211 45L211 49C211.71 47.2405 211.71 46.7595 211 45z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d8d9d9",
      stroke: "none"
    },
    d: "M227 45L227 49C227.71 47.2405 227.71 46.7595 227 45z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#454746",
      stroke: "none"
    },
    d: "M238 45L238 49C238.71 47.2405 238.71 46.7595 238 45z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8e908f",
      stroke: "none"
    },
    d: "M243 45L243 49C243.71 47.2405 243.71 46.7595 243 45z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#99f4e8",
      stroke: "none"
    },
    d: "M59 46L60 47L59 46z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#636463",
      stroke: "none"
    },
    d: "M85 46L86 47L85 46z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#afb0af",
      stroke: "none"
    },
    d: "M97 46L98 47L97 46z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#757675",
      stroke: "none"
    },
    d: "M130 46L131 47L130 46z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a9aaa9",
      stroke: "none"
    },
    d: "M135 46L136 47L135 46z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8c8e8c",
      stroke: "none"
    },
    d: "M139 46L140 47L139 46z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#939494",
      stroke: "none"
    },
    d: "M144 46L145 47L144 46z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d3d4d4",
      stroke: "none"
    },
    d: "M86 47L87 48L86 47z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5e5f5e",
      stroke: "none"
    },
    d: "M135 47L136 48L135 47z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cebffc",
      stroke: "none"
    },
    d: "M24 48L25 49L24 48z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9673f9",
      stroke: "none"
    },
    d: "M36 48L37 49L36 48z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a1a0",
      stroke: "none"
    },
    d: "M89 48L90 49L89 48z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#595c5a",
      stroke: "none"
    },
    d: "M99 48L100 49L99 48z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#adaeae",
      stroke: "none"
    },
    d: "M92 49L93 50L92 49z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#636563",
      stroke: "none"
    },
    d: "M93 49L94 50L93 49z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9d9f9e",
      stroke: "none"
    },
    d: "M131 49L132 50L131 49z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cdcecd",
      stroke: "none"
    },
    d: "M136 49L137 50L136 49z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cecece",
      stroke: "none"
    },
    d: "M138 49L139 50L138 49z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b7b8b7",
      stroke: "none"
    },
    d: "M143 49L144 50L143 49z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#989999",
      stroke: "none"
    },
    d: "M163 49L164 50L163 49z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#727473",
      stroke: "none"
    },
    d: "M195 49L196 50L195 49z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#999a99",
      stroke: "none"
    },
    d: "M227 49L228 50L227 49z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d6d6d6",
      stroke: "none"
    },
    d: "M243.333 49.6667C243.278 49.7222 243.222 50.7778 243.667 50.3333C243.722 50.2777 243.778 49.2222 243.333 49.6667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#dbdcdc",
      stroke: "none"
    },
    d: "M83 50C84.7691 50.7789 86.0359 50.9124 88 51C86.231 50.2211 84.9641 50.0876 83 50z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#989999",
      stroke: "none"
    },
    d: "M100 50L100 53C100.696 51.4463 100.696 51.5537 100 50z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#858686",
      stroke: "none"
    },
    d: "M108 50L109 51L108 50z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cecece",
      stroke: "none"
    },
    d: "M118 50L119 51L118 50z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8d8f8e",
      stroke: "none"
    },
    d: "M136 50L137 51L136 50z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d7f7e",
      stroke: "none"
    },
    d: "M138 50L139 51L138 50z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#535454",
      stroke: "none"
    },
    d: "M158 50L159 51L158 50z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#515252",
      stroke: "none"
    },
    d: "M163 50L164 51L163 50z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#aaabaa",
      stroke: "none"
    },
    d: "M195 50L196 51L195 50z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4e504f",
      stroke: "none"
    },
    d: "M227 50L228 51L227 50z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8a2fb",
      stroke: "none"
    },
    d: "M26 51L27 52L26 51z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9673f8",
      stroke: "none"
    },
    d: "M35 51L36 52L35 51z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3d3f3e",
      stroke: "none"
    },
    d: "M95.3333 51.6667C95.2778 51.7222 95.2222 52.7778 95.6667 52.3333C95.7222 52.2778 95.7778 51.2222 95.3333 51.6667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#747575",
      stroke: "none"
    },
    d: "M103 51L104 52L103 51z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#515352",
      stroke: "none"
    },
    d: "M118 51L119 52L118 51z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4c4f4d",
      stroke: "none"
    },
    d: "M132 51L133 52L132 51z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9fa0a0",
      stroke: "none"
    },
    d: "M158 51L159 52L158 51z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2b2b2",
      stroke: "none"
    },
    d: "M172 51L173 52L172 51z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M175 51L176 52L175 51z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bebebe",
      stroke: "none"
    },
    d: "M201 51L202 52L201 51z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bfbfbf",
      stroke: "none"
    },
    d: "M210 51L211 52L210 51z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6e6f6f",
      stroke: "none"
    },
    d: "M237 51L238 52L237 51z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a88afa",
      stroke: "none"
    },
    d: "M27 52L28 53L27 52z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9d9e9d",
      stroke: "none"
    },
    d: "M88 52L89 53L88 52z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#767877",
      stroke: "none"
    },
    d: "M117 52L118 53L117 52z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c3c4c4",
      stroke: "none"
    },
    d: "M132 52L133 53L132 52z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cececf",
      stroke: "none"
    },
    d: "M142 52L143 53L142 52z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cbcbcb",
      stroke: "none"
    },
    d: "M171 52L172 53L171 52z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8a8b8b",
      stroke: "none"
    },
    d: "M177 52L178 53L177 52z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d2d3d2",
      stroke: "none"
    },
    d: "M202 52L203 53L202 52z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d2d2d2",
      stroke: "none"
    },
    d: "M209 52L210 53L209 52z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a4a3",
      stroke: "none"
    },
    d: "M236 52L237 53L236 52z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#777978",
      stroke: "none"
    },
    d: "M242 52L243 53L242 52z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a386fa",
      stroke: "none"
    },
    d: "M28 53L29 54L28 53z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#71f0df",
      stroke: "none"
    },
    d: "M52 53L52 57C52.7102 55.2405 52.7102 54.7595 52 53z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b1f7ed",
      stroke: "none"
    },
    d: "M61 53L61 57C61.7102 55.2405 61.7102 54.7595 61 53z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdbebe",
      stroke: "none"
    },
    d: "M83 53L84 54L83 53z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#949695",
      stroke: "none"
    },
    d: "M89 53L90 54L89 53z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#eaeaea",
      stroke: "none"
    },
    d: "M90 53C91.506 53.683 92.3148 53.8259 94 54C92.494 53.317 91.6852 53.1741 90 53z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#686a69",
      stroke: "none"
    },
    d: "M94 53L95 54L94 53z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#636464",
      stroke: "none"
    },
    d: "M104 53L105 54L104 53z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7b7c7b",
      stroke: "none"
    },
    d: "M111 53L112 54L111 53z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bebfbf",
      stroke: "none"
    },
    d: "M112 53C113.248 53.6848 113.548 53.7488 115 54C113.752 53.3152 113.452 53.2512 112 53z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#888989",
      stroke: "none"
    },
    d: "M115 53L116 54L115 53z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6b6c6c",
      stroke: "none"
    },
    d: "M119 53L120 54L119 53z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a4a4",
      stroke: "none"
    },
    d: "M159 53L160 54L159 53z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6c6d6c",
      stroke: "none"
    },
    d: "M166 53L167 54L166 53z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bcbdbc",
      stroke: "none"
    },
    d: "M167 53C168.248 53.6848 168.548 53.7488 170 54C168.752 53.3152 168.452 53.2512 167 53z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#646665",
      stroke: "none"
    },
    d: "M170 53L171 54L170 53z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d0d1d1",
      stroke: "none"
    },
    d: "M196 53L197 54L196 53z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5b5d5c",
      stroke: "none"
    },
    d: "M203 53L204 54L203 53z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#babbbb",
      stroke: "none"
    },
    d: "M204 53C205.506 53.683 206.315 53.8259 208 54C206.494 53.317 205.685 53.1741 204 53z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a5b5a",
      stroke: "none"
    },
    d: "M208 53L209 54L208 53z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#454746",
      stroke: "none"
    },
    d: "M211.667 53.3333C211.222 53.7778 212.278 53.7222 212.333 53.6667C212.778 53.2222 211.722 53.2778 211.667 53.3333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#484a4a",
      stroke: "none"
    },
    d: "M226.667 53.3333C226.222 53.7778 227.278 53.7222 227.333 53.6667C227.778 53.2223 226.722 53.2778 226.667 53.3333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6c6d6c",
      stroke: "none"
    },
    d: "M230 53L231 54L230 53z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdbdbd",
      stroke: "none"
    },
    d: "M231 53C232.506 53.683 233.315 53.8259 235 54C233.494 53.317 232.685 53.1741 231 53z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#af92fa",
      stroke: "none"
    },
    d: "M29 54L30 55L29 54z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b9a2fb",
      stroke: "none"
    },
    d: "M31 54L32 55L31 54z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6d6f6e",
      stroke: "none"
    },
    d: "M99 54L100 55L99 54z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7f8080",
      stroke: "none"
    },
    d: "M118 54L119 55L118 54z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#585a59",
      stroke: "none"
    },
    d: "M133 54L134 55L133 54z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#646564",
      stroke: "none"
    },
    d: "M141 54L142 55L141 54z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4e4f4f",
      stroke: "none"
    },
    d: "M160 54L161 55L160 54z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c0c1c0",
      stroke: "none"
    },
    d: "M176 54L177 55L176 54z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5c5e5d",
      stroke: "none"
    },
    d: "M197 54L198 55L197 54z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f908f",
      stroke: "none"
    },
    d: "M212 54L212 57C212.696 55.4463 212.696 55.5537 212 54z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bebfbf",
      stroke: "none"
    },
    d: "M226 54L226 57C226.696 55.4463 226.696 55.5537 226 54z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9b9a",
      stroke: "none"
    },
    d: "M241 54L242 55L241 54z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6f6eb",
      stroke: "none"
    },
    d: "M30 55L30 58C30.6961 56.4463 30.6961 56.5537 30 55z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bebfbf",
      stroke: "none"
    },
    d: "M175 55L176 56L175 55z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969797",
      stroke: "none"
    },
    d: "M228 55L229 56L228 55z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#757575",
      stroke: "none"
    },
    d: "M240 55L241 56L240 55z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8af2e4",
      stroke: "none"
    },
    d: "M28 56L29 57L28 56z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4c4e4d",
      stroke: "none"
    },
    d: "M86 56L87 57L86 56z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a5b5b",
      stroke: "none"
    },
    d: "M97 56L98 57L97 56z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a4a5a5",
      stroke: "none"
    },
    d: "M162 56L163 57L162 56z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#878887",
      stroke: "none"
    },
    d: "M199 56L200 57L199 56z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bababa",
      stroke: "none"
    },
    d: "M209 56L210 57L209 56z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7f8080",
      stroke: "none"
    },
    d: "M229 56L230 57L229 56z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2b3b3",
      stroke: "none"
    },
    d: "M239 56L240 57L239 56z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d0d0d0",
      stroke: "none"
    },
    d: "M87 57L88 58L87 57z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#787979",
      stroke: "none"
    },
    d: "M88 57L89 58L88 57z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#808280",
      stroke: "none"
    },
    d: "M95 57L96 58L95 57z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c3c4c3",
      stroke: "none"
    },
    d: "M108 57L109 58L108 57z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#626463",
      stroke: "none"
    },
    d: "M109 57L110 58L109 57z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a4a3",
      stroke: "none"
    },
    d: "M115 57L116 58L115 57z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9c9c9c",
      stroke: "none"
    },
    d: "M120 57C121.769 57.7789 123.036 57.9124 125 58C123.231 57.2211 121.964 57.0876 120 57z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9b9c9c",
      stroke: "none"
    },
    d: "M134 57C136.332 57.9845 138.457 57.9813 141 58C138.668 57.0155 136.543 57.0187 134 57z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9c9c9c",
      stroke: "none"
    },
    d: "M150 57C151.769 57.7789 153.036 57.9124 155 58C153.231 57.2211 151.964 57.0876 150 57z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ababab",
      stroke: "none"
    },
    d: "M164 57L165 58L164 57z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#525453",
      stroke: "none"
    },
    d: "M165 57L166 58L165 57z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#747574",
      stroke: "none"
    },
    d: "M171 57L172 58L171 57z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cdcdcd",
      stroke: "none"
    },
    d: "M172 57L173 58L172 57z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#919191",
      stroke: "none"
    },
    d: "M187 57C188.769 57.779 190.036 57.9124 192 58C190.231 57.2211 188.964 57.0876 187 57z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#878888",
      stroke: "none"
    },
    d: "M201 57L202 58L201 57z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#767777",
      stroke: "none"
    },
    d: "M207 57L208 58L207 57z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cdcdcd",
      stroke: "none"
    },
    d: "M212 57L213 58L212 57z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9c9c9c",
      stroke: "none"
    },
    d: "M213 57C214.506 57.683 215.315 57.8259 217 58C215.494 57.317 214.685 57.1741 213 57z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9b9c9c",
      stroke: "none"
    },
    d: "M221 57C222.769 57.779 224.036 57.9124 226 58C224.231 57.2211 222.964 57.0876 221 57z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cecfce",
      stroke: "none"
    },
    d: "M230 57L231 58L230 57z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5e5f5f",
      stroke: "none"
    },
    d: "M231 57L232 58L231 57z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9f9f9f",
      stroke: "none"
    },
    d: "M237 57L238 58L237 57z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#aaf6ec",
      stroke: "none"
    },
    d: "M25 58L26 59L25 58z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#74f1e0",
      stroke: "none"
    },
    d: "M22 61L23 62L22 61z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b4f7ee",
      stroke: "none"
    },
    d: "M32 61L33 62L32 61z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a4f5ea",
      stroke: "none"
    },
    d: "M50 61L51 62L50 61z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93f3e6",
      stroke: "none"
    },
    d: "M60 61L61 62L60 61z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2f7ed",
      stroke: "none"
    },
    d: "M35 64L36 65L35 64z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#98f4e7",
      stroke: "none"
    },
    d: "M47 64L48 65L47 64z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a7f5eb",
      stroke: "none"
    },
    d: "M37 65L38 66L37 65z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#97f4e7",
      stroke: "none"
    },
    d: "M45 65L46 66L45 65z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#55eed9",
      stroke: "none"
    },
    d: "M39 66C40.506 66.683 41.3148 66.8259 43 67C41.494 66.317 40.6852 66.1741 39 66z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9af5e8",
      stroke: "none"
    },
    d: "M25 67L26 68L25 67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8bf3e4",
      stroke: "none"
    },
    d: "M56 68L57 69L56 68z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#79f1e1",
      stroke: "none"
    },
    d: "M55 69L56 70L55 69z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#84f2e3",
      stroke: "none"
    },
    d: "M28 70L29 71L28 70z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9af4e8",
      stroke: "none"
    },
    d: "M54 70L55 71L54 70z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#adf7ec",
      stroke: "none"
    },
    d: "M29 71L30 72L29 71z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b5f7ee",
      stroke: "none"
    },
    d: "M35 74L36 75L35 74z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cbfaf3",
      stroke: "none"
    },
    d: "M38 75C40.0521 75.8742 41.7472 75.9528 44 76C41.9479 75.1258 40.2528 75.0472 38 75z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.4b53fc49d5fe54045a6e75218236a647.svg";
export { ForwardRef as ReactComponent };